import styled from "styled-components";
import Button from "~/componentes/Button";
import { Colors } from "~/config/Colors";

export const ThisButton = styled(Button)`
  position: relative;
  width: 100%;
  height: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0 0.5rem;
  border: 0;
  border-radius: 0.5625rem;
  ${({ bgColorSelect }) => `background: ${bgColorSelect};`}

  :hover {
    p {
      ${({ selected, ftColorSelect }) => {
        return `color: ${ftColorSelect};`;
      }}
    }
  }

  img {
    width: 1.5rem;
    margin-right: 0.7rem;
  }

  p {
    ${({ ftColorSelect }) => `color: ${ftColorSelect};`}
    font-size: 0.7rem;
    font-weight: 600;
  }
`;
